import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { COLUMNS } from './columns'
import { COLUMNS_EXCLUDED_ITEMS } from './columnsItemsExcluded'
import Glyph from 'component/utils/Glyph'
import Row from 'component/utils/Row'
import FilterForm from './Filter'
import Modal from './Modal'
import iconDownload from 'images/icon-download.svg'
import moment from 'moment'
import { typeLogList } from './typeLogList'

class TableQueryLog extends Component {
  state = {
    clicked: false,
    renderModal: false,
    log: null,
    stretchedOut: false,
    maxLength: 150,
  }

  getOrderTitle = (log) => {
    switch (true) {
      case !!log.orderNumber:
        return 'query.logs.modal.orderNumber'

      case !!log.documentNumber:
        return 'query.logs.modal.documentNumber'

      default:
        return ''
    }
  }

  getTxt = (log) => {
    const { translate } = this.props
    const element = document.createElement('a')

    const file = new Blob(
      [
        `\n${translate('totem.query.logs.modal.functionality')}\n`,
        translate(this.getTable()),
        '\n\n',
        translate(this.getOrderTitle(log)),
        '\n',
        log.orderNumber || log.documentNumber,
        '\n\n',
        translate('query.logs.modal.endpoint'),
        '\n',
        log.endpoint ? log.endpoint : '-',
        '\n\n',
        translate('query.logs.modal.date'),
        '\n',
        moment(log.creatTs).format('l'),
        '\n\n',
        translate('query.logs.modal.hour'),
        '\n',
        moment(log.creatTs).format('LT'),
        '\n\n',
        translate('query.logs.modal.request'),
        '\n',
        log.dsRequest,
        '\n\n',
        translate('query.logs.modal.response'),
        '\n',
        log.dsResponse,
      ],
      { type: 'text/plain' }
    )

    element.href = URL.createObjectURL(file)
    element.download = 'logs.txt'
    // Required for this to work in FireFox
    document.body.appendChild(element)
    element.click()
    element.parentElement.removeChild(element)
  }

  getTable = () => {
    const { valuesFilter } = this.props
    const value = typeLogList.filter((e) => e.type === valuesFilter.logType)[0]
    if (value) {
      return value.label
    }
    return ''
  }

  renderModal = () => {
    const { translate } = this.props
    const { renderModal, log } = this.state

    if (!renderModal) {
      return
    }

    return (
      <Modal
        translate={translate}
        closeModal={() =>
          this.setState({
            renderModal: false,
            log: null,
          })
        }
        log={log}
        getTxt={() => this.getTxt(log)}
        tableFiltered={this.getTable(log)}
      />
    )
  }

  renderColumn = (key, data, classNameCol) => (
    <td className={classNameCol || 'td-log'} key={key}>
      {data}
    </td>
  )

  renderLabelContent = (value) =>
    value.length > this.state.maxLength
      ? `${value.substring(0, this.state.maxLength)}...`
      : value

  renderLabelDate = (value) =>
    `${moment(value).format('l')} ${moment(value).format('LT')}`

  renderRow = (row, i) => (
    <tr key={i} className={i % 2 && 'query-logTable-nth-child'}>
      {this.renderColumn('date', this.renderLabelDate(row.creatTs), 'log-8')}
      {this.renderColumn('request', this.renderLabelContent(row.dsRequest))}
      {this.renderColumn('response', this.renderLabelContent(row.dsResponse))}
      {this.renderColumn(
        'details',
        <span
          onClick={() => this.setState({ renderModal: true, log: row })}
          className='table-icon'
        >
          <Glyph type='eye' color='primary' />
        </span>,
        'log-8'
      )}

      {this.renderColumn(
        'download',
        <a
          href='#'
          className='table-icon-iconDownload'
          onClick={() => this.getTxt(row)}
        >
          <img src={iconDownload} />
        </a>,
        'log-8'
      )}
    </tr>
  )

  renderHeader = (column) => {
    const { translate } = this.props
    return (
      <th className='th-log' key={column.label}>
        <div className={`cell small-column ${column.className}`}>
          <div className='th-log'>
            {translate(`queryLogs.table.column.${column.label}`)}
          </div>
        </div>
      </th>
    )
  }

  renderExcludedRow = (row, i) => (
    <tr key={i} className={i % 2 && 'query-logTable-nth-child'}>
      {this.renderColumn('date', this.renderLabelDate(row.creatTs), 'log-8')}
      {this.renderColumn('nuOrder', row.nuOrder)}
      {this.renderColumn('user', row.lastUserCd || '-')}
      {this.renderColumn('reason', row.reason)}
    </tr>
  )

  submit = (value) => this.props.submit(value)

  renderForm = () => {
    const { clicked, stretchedOut } = this.state
    const { translate, valuesFilter, user } = this.props

    if (clicked) {
      return (
        <div className='log-filter'>
          <FilterForm
            translate={translate}
            filters={valuesFilter}
            handleSubmit={this.submit}
            title={translate('queryLogs.table.title')}
            classFilter='log-filter-form-clicked'
            user={user}
            stretchedOut={stretchedOut}
            classTitle
          />
        </div>
      )
    }
  }

  clickFilter = () => {
    const { clicked } = this.state
    this.setState({ clicked: !clicked, stretchedOut: true })
  }

  renderTable = () => {
    const { logs, translate } = this.props
    if (logs.length) {
      const isExcludedItems = logs && 'nuOrder' in (logs[0] || {})
      return (
        <div className='totem-log-table-container'>
          <table className='table bordered query-logTable'>
            <thead>
              <tr className='thead-log'>
                {isExcludedItems
                  ? COLUMNS_EXCLUDED_ITEMS.map(this.renderHeader)
                  : COLUMNS.map(this.renderHeader)}
              </tr>
            </thead>
            <tbody>
              {logs &&
                logs.map(
                  isExcludedItems
                    ? this.renderExcludedRow
                    : this.renderRow
                )}
            </tbody>
          </table>
        </div>
      )
    }
    return (
      <div className='totem-log-table-container'>
        <div className='notification notification-warning'>
          {translate('query.logs.result.empty')}
        </div>
      </div>
    )
  }

  renderExcluded = () => {
    COLUMNS_EXCLUDED_ITEMS.map(this.renderHeader)
  }

  renderOthers = () => {
    COLUMNS.map(this.renderHeader)
  }

  render() {
    const { clicked } = this.state
    const { translate } = this.props
    return (
      <div className='log-table'>
        {this.renderForm()}
        <div
          className={clicked ? 'query-log-table-clicked' : 'query-log-table'}
        >
          <Row className='query-log'>
            <span className='button-log' onClick={this.clickFilter}>
              <i
                className={`glyph glyph-grey icon glyph-${
                  clicked ? 'double-arrow-left' : 'double-arrow-right'
                }`}
              />
              <span className='query-log-label'>
                {translate('queryLogs.table.title')}
              </span>
            </span>
          </Row>
          {this.renderTable()}
        </div>
        {this.renderModal()}
      </div>
    )
  }
}

export default TableQueryLog

TableQueryLog.propTypes = {
  translate: PropTypes.func,
  logs: PropTypes.array,
  submit: PropTypes.func,
  count: PropTypes.number,
  current: PropTypes.number,
  handlePagination: PropTypes.func,
  pages: PropTypes.number,
  user: PropTypes.object,
  valuesFilter: PropTypes.object,
}
